import { MainMenuItemInterface } from '@actassa/api';
import { InjectionToken } from '@angular/core';

export const MAIN_MENU_ITEMS_TOKEN = new InjectionToken<Array<MainMenuItemInterface>>('MAIN_MENU_ITEMS_TOKEN');
